import * as types from './mutation-types'
import routes from 'router/router.config';
import { getRootRoute } from 'utils/menu';
import Message from './modules/message'
import { redirectToNeiXin } from 'utils/neixin';

// 在此维护消息系统的单例
const messsage = new Message();

export default {
    [types.SET_BIZ_USER_INFO](state, payload) {
        const { authBizlineInfos } = payload
        state.bizAuthInfo = authBizlineInfos
        let rootRoute = getRootRoute(routes);
        redirectToNeiXin(payload);
        if (rootRoute && rootRoute.children && rootRoute.children.length) {
            let accountRoute = rootRoute.children.find((childRoute) => {
                return childRoute.path === 'account';
            });
            let routeName = 'subAccount';
            if (payload.accountType === 1) {
                routeName = 'adminAccount';
            }
            if (accountRoute && accountRoute.children) {
                let accountMenuRoute = accountRoute.children.find((childRoute) => {
                    return childRoute.name === routeName;
                });
                accountMenuRoute.meta.notMenu = false;
            }
        }
        if (payload) {
            payload.id = payload.userId
            payload.name = payload.userName
            state.bizUser = payload
        }
    },
    [types.SET_MIS_USER_INFO](state, payload) {
        state.misUser = Object.assign(state.misUser, payload)
    },
    [types.SET_PAGE_ACCOUNT_TYPE](state, payload) {
        state.pageAccountType = payload || 'biz'
    },
    // 登出时清空信息；
    [types.CLEAR_USER_INFO](state) {
        // clear cart
        state.bizUser = {};
        state.bizAuthInfo = {};
        state.sfCustoms = null;
    },

    // 记录登录页之前的页面；
    [types.SET_FROM_PAGE](state, payload) {
        // clear cart
        if (payload) {
            state.fromPage = payload
        }
    },
    [types.SET_CUSTOMS](state, payload) {
        if (payload) {
            state.sfCustoms = payload;
        }
    },
    [types.SET_TRIP_NOTIFY](state, data) {
        // 3f的系统，只有商家登录
        const userId = state.bizUser.id;
        const res = messsage.updateUnread(userId, data)
        if (res) {
            state.unreadMap = res;
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js